import { render, staticRenderFns } from "./UserInvitation.vue?vue&type=template&id=4389635e&scoped=true&"
import script from "./UserInvitation.vue?vue&type=script&lang=js&"
export * from "./UserInvitation.vue?vue&type=script&lang=js&"
import style0 from "./UserInvitation.vue?vue&type=style&index=0&id=4389635e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4389635e",
  null
  
)

export default component.exports